import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import "react-times/css/classic/default.css";
import DatePicker from "components/sales/datePicker/datePicker";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import useLatLng from "hooks/uselatlng/uselatlng";
import CustomModal from "../../valetServices/modal";
import GoogleMapReact from "google-map-react";
import { toast } from "react-toastify";
import FormSection from "components/sales/formSection/formSectionNew";

const EngineerTasksForm = ({
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  getCitiesList,
  siteByCity,
  siteDetails = [],
  createTaskResponse = [],
  createTask,
  getSiteData,
  siteDetailsList,
  subHardwareDropdown,
  subHardwareDropdownList = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  let markers = [];
  const [inputList, setInputList] = useState([
    {
      // city_id: '',
      site_id: "",
      date: "",
      lat: "",
      long: "",
      image_url: "",
      desc: "",
      l2_ticket: "",
      task_type: "",
      rfid_status: "",
      other_flow_remark: "",
      hardware: "",
      requested_by: "",
      hardware_component: "",
      hardware_function: "",
      remarks: "",
    },
  ]);

  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [l2, setL2] = useState(false);
  const [city, setCity] = useState([]);
  const [desc, setDesc] = useState("");
  const [date, setDate] = useState("");
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [count, setCount] = useState(0);
  const [totalDistance, setDistance] = useState("");
  const [parentName, setParentName] = useState("");
  const [subHardware, setSubHardware] = useState([]);
  const [siteLocation, setSiteLocaation] = useState({
    lat: 0,
    long: 0,
  });
  const [showInput, setShowInput] = useState(false);
  const [sections, setSections] = useState([{ id: 0 }]);
  const [hardwareIndex, setHardwareIndex] = useState(0);

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  const handleInputList = (val, index) => {
    let list = [...inputList];
    list[0][index] = val;
    setInputList([...list]);
  };

  const toRad = (Value) => {
    return (Value * Math.PI) / 180;
  };

  const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const data = await getCitiesList();
      getSiteData(0);
      await siteByCity({ city_id: 0 });
      if (data) {
        setCity(data?.response?.data);
      }
      setIsLoading(false);
    })();
  }, []);

  const handleL2Ticket = (e) => {
    let isChecked = e.target.checked;
    isChecked ? setL2(true) : setL2(false);
  };

  const handleCityChange = async (id) => {
    if (id === "") {
      return true;
    }
    setIsLoading(true);
    await siteByCity({ city_id: 0 });
    setIsLoading(false);
  };

  const handleSiteData = async (siteId) => {
    if (siteId === "") {
      return false;
    }
    setIsLoading(true);
    getSiteData(siteId);
    setIsLoading(false);
  };

  const handleTaskType = (id) => {
    if (id == "Call support") {
      setShowInput(true);
    } else {
      setShowInput(false);
    }
  };

  useEffect(() => {
    setDate(siteDetails?.response?.data?.todayDate);
  }, [siteDetails]);

  useEffect(() => {
    if (
      siteDetailsList !== undefined &&
      siteDetailsList !== null &&
      Object.keys(siteDetailsList).length > 0
    ) {
      let distance = calcCrow(
        islatlng?.lat,
        islatlng?.lng,
        siteDetailsList?.lead?.latitude,
        siteDetailsList?.lead?.longitude
      );
      setDistance(distance);
      setSiteLocaation({
        lat: siteDetailsList?.lead?.latitude,
        long: siteDetailsList?.lead?.longitude,
      });
    }
  }, [islatlng?.lat, siteDetailsList]);

  const handleSubmit = async () => {
    if (isAllow) {
      alert(localization.locationPermission);
    }
    let list = [...inputList];
    if (list[0]["site_id"] == "" || list[0]["task_type"] == "") {
      toast.error("Please fill all required fields.");
      return false;
    }
    list[0]["lat"] = islatlng?.lat;
    list[0]["long"] = islatlng?.lng;
    list[0]["l2_ticket"] = l2;
    list[0]["desc"] = desc;
    list[0]["date"] = date;
    list[0]["hardware"] = sections;

    // console.log("Lisitng:", list[0]);
    // return false;
    setIsLoading(true);
    let res = await createTask(list[0]);
    setCount(count + 1);
    setIsLoading(false);
  };

  const dropdownDataRfid = [
    { id: "ANPR", name: "ANPR" },
    { id: "BOOKING SOFTWARE", name: "BOOKING SOFTWARE" },
    { id: "FASTAG ACCESS", name: "FASTAG ACCESS" },
    { id: "FASTAG ACCESS/CHARGING", name: "FASTAG ACCESS/CHARGING" },
    { id: "FASTAG ACCESS/CHARGING-ANPR", name: "FASTAG ACCESS/CHARGING-ANPR" },
    { id: "FASTAG CHARGING", name: "FASTAG CHARGING" },
    { id: "FASTAG CHARGING-ANPR", name: "FASTAG CHARGING-ANPR" },
    {
      id: "FASTAG CHARGING-IMAGE CAPTURE",
      name: "FASTAG CHARGING-IMAGE CAPTURE",
    },
    { id: "FASTAG INTEGRATION", name: "FASTAG INTEGRATION" },
    { id: "Inventory management", name: "Inventory management" },
    { id: "Inventory Management/ANPR", name: "Inventory Management/ANPR" },
    { id: "LOOP COUNTER", name: "LOOP COUNTER" },
    { id: "MANUAL", name: "MANUAL" },
    { id: "PGS & TVM", name: "PGS & TVM" },
    { id: "RFID", name: "RFID" },
    { id: "RFID -ANPR", name: "RFID -ANPR" },
    { id: "RFID Fastag Integration", name: "RFID Fastag Integration" },
    { id: "RFID-ANPR", name: "RFID-ANPR" },
    { id: "RFID-IMAGE CAPTURE", name: "RFID-IMAGE CAPTURE" },
    { id: "RFID-Subgating", name: "RFID-Subgating" },
    { id: "Others", name: "Others" },
  ];

  const handleAddSection = () => {
    setSections([...sections, { id: sections.length }]);
  };

  const handleRemoveSection = (index) => {
    setSections(sections.filter((_, i) => i !== index));
  };

  function renderMarkers(map, maps) {
    markers = [
      {
        title: "eng site",
        position: { lat: Number(islatlng?.lat), lng: Number(islatlng?.lng) },
      },
    ];

    if (siteLocation.lat !== undefined) {
      markers.push({
        title: "Site",
        position: {
          lat: Number(siteLocation.lat),
          lng: Number(siteLocation.long),
        },
      });
      {
        markers.map(
          (marker1, index) =>
            new maps.Marker({
              key: index,
              position: marker1.position,
              name: marker1.name,
              map,
              title: marker1.title == "eng site" ? "You are here!" : "Site",
              icon: {
                url:
                  marker1.title == "eng site"
                    ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                    : "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
              },
            })
        );
      }
    }
  }

  const handleInputDropdownList = (id, type, index) => {
    const newSections = [...sections];
    if (type === "hardware") {
      newSections[index].hardware = id;
    } else {
      newSections[index][type] = id;
    }
    setHardwareIndex(index);
    setSections(newSections);
  };

  const handleStatusDropdownList = (id, index, childId, childName) => {
    const newSections = [...sections];
    if (!Array.isArray(newSections[hardwareIndex].childData)) {
      newSections[hardwareIndex].childData = [];
    }

    if (!newSections[hardwareIndex].childData[index]) {
      newSections[hardwareIndex].childData[index] = {};
    }

    newSections[hardwareIndex].childData[index]["child_id"] = childId;
    newSections[hardwareIndex].childData[index]["status"] = id;
    newSections[hardwareIndex].childData[index]["child_name"] = childName;
    setSections(newSections);
  };

  const handleRemarkDropdownList = (val, index) => {
    const newSections = [...sections];
    if (!Array.isArray(newSections[hardwareIndex].childData)) {
      newSections[hardwareIndex].childData = [];
    }

    if (!newSections[hardwareIndex].childData[index]) {
      newSections[hardwareIndex].childData[index] = {};
    }
    newSections[hardwareIndex].childData[index]["remark"] = val;
    setSections(newSections);
  };

  const handleHardwareChange = (parentId) => {
    if (parentId) {
      (async () => {
        setIsLoading(true);
        const status = await subHardwareDropdown(parentId);
        setIsLoading(false);
      })();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const newSections = [...sections];
      newSections[hardwareIndex].child =
        subHardwareDropdownList?.data?.sub_hardware_dropdown;
      // setSubHardware(subHardwareDropdownList?.data?.sub_hardware_dropdown)
      setSections(newSections);
      setIsLoading(false);
    })();
  }, [subHardwareDropdownList?.data?.sub_hardware_dropdown]);

  return (
    <Layout
      title={localization.addtask}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/tasks_engg`}
    >
      <div className="container-fluid">
        {createTaskResponse !== [] &&
          createTaskResponse?.status_code !== 200 &&
          createTaskResponse?.status !== 0 && (
            <CustomModal
              msg={createTaskResponse?.response?.message || createTaskResponse?.message}
              click={count}
            />
          )}
        {createTaskResponse !== [] &&
          (createTaskResponse?.status_code === 200 ||
            createTaskResponse?.status === 0 ||
            createTaskResponse?.response?.status === 200 ||
            createTaskResponse?.response?.status === true) && (
            <CustomModal
              msg={createTaskResponse?.response?.message || createTaskResponse?.message}
              isPageLoad={true}
              click={count}
            />
          )}
        <div className="card">
          <div className="card-body">
            <div className="row">
              {/*<div className="col-md-12">*/}
              {/*<div className="col-sm-4">*/}
              {/*    <DropDownInput*/}
              {/*        name="category"*/}
              {/*        data={city}*/}
              {/*        label={localization.city}*/}
              {/*        required={true}*/}
              {/*        isStarRequired={true}*/}
              {/*        errorMsg={localization.isRequired}*/}
              {/*        getIdValue={(val) => {*/}
              {/*            handleInputList(val.id, 'city_id')*/}
              {/*            handleCityChange(val.id);*/}
              {/*        }}*/}
              {/*        value={''}*/}
              {/*    />*/}
              {/*</div>*/}
              <div className="col-sm-4">
                <DropDownInput
                  data={siteDetails?.response?.data?.sites}
                  label={localization.site}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => {
                    handleSiteData(val.id);
                    handleInputList(val.id, "site_id");
                  }}
                  value={""}
                />
              </div>
              <div className="col-sm-4">
                <DatePicker
                  handleChange={(val) => {
                    setDate(val);
                  }}
                  label={`Date`}
                  required={false}
                  value={siteDetails?.response?.data?.todayDate}
                />
              </div>
              {/*</div>*/}
              <div className="col-sm-4">
                <ConstantInput
                  label={localization.lat}
                  value={islatlng?.lat}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  //disabled={disabled}
                  handleChange={(val) => {
                    handleInputList(val, "lat");
                  }}
                  disabled={true}
                />
              </div>
              <div className="col-sm-4">
                <ConstantInput
                  label={localization.lng}
                  value={islatlng?.lng}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  //disabled={disabled}
                  handleChange={(val) => {
                    handleInputList(val, "long");
                  }}
                  disabled={true}
                />
              </div>
              <div className="col-sm-4">
                <DropDownInput
                  data={[
                    { id: "New Site Config", name: "New Site Config" },
                    {
                      id: "Existing Site Config",
                      name: "Existing Site Config",
                    },
                    { id: "New Site Testing", name: "New Site Testing" },
                    { id: "Troubleshooting", name: "Troubleshooting" },
                    { id: "Call support", name: "Call support" },
                    { id: "Others", name: "Others" },
                  ]}
                  label={`Task Type`}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => {
                    handleTaskType(val.id);
                    handleInputList(val.id, "task_type");
                  }}
                  value={""}
                />
              </div>
              <div className="col-sm-4">
                <FileUpload
                  id={"fileAttach"}
                  accept=".pdf,.png,.jpg,.jpeg,.doc"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(val) => handleInputList(val, "image_url")}
                >
                  <span className="btn btn-transparent">
                    {localization.media}
                  </span>
                </FileUpload>
              </div>

              {inputList &&
                inputList[0] &&
                inputList[0].task_type &&
                inputList[0].task_type === "New Site Config" && (
                  <>
                    <div className="col-sm-4">
                      <DropDownInput
                        data={dropdownDataRfid}
                        label={`Flow`}
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        getIdValue={(val) => {
                          handleInputList(val.id, "rfid_status");
                        }}
                        value={""}
                      />
                    </div>
                    {inputList[0].rfid_status === "Others" && (
                      <div className="col-sm-4">
                        <ConstantInput
                          label={'Other Remark'}
                          required={true}
                          isStarRequired={true}
                          errorMsg={localization.isRequired}
                          handleChange={(val) => {
                            handleInputList(val, "other_flow_remark");
                          }}
                        />
                    </div>
                    )}
                    {inputList[0].rfid_status && (
                      <div className="col-md-12 mb-4">
                        <FormSection>
                          <div className="row">
                            {console.log("test:", sections)}
                            {sections.map((section, index) => (
                              <React.Fragment key={section.id}>
                                <div className="col-sm-4">
                                  <DropDownInput
                                    data={
                                      siteDetails?.response?.data
                                        ?.hardware_dropdown
                                    }
                                    label={`Hardware`}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    getIdValue={(val) => {
                                      handleInputDropdownList(
                                        val.id,
                                        "hardware",
                                        index
                                      );
                                      handleHardwareChange(
                                        sections[index].hardware
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>

                                {index !== 0 && (
                                  <div className="col-sm-2">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleRemoveSection(index)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                )}

                                {sections[index].hardware &&
                                  sections[index].child && (
                                    <div className="col-md-12 mb-4">
                                      <FormSection
                                        title={
                                          subHardwareDropdownList?.data
                                            ?.parent_name[0]?.name
                                        }
                                      >
                                        <div className="row">
                                          {sections[index].child?.map(
                                            (item, i) => (
                                              <div
                                                className="col-md-12 mb-4"
                                                key={i}
                                              >
                                                <>
                                                  <div className="col-md-12">
                                                    <div className="col-md-4">
                                                      <ConstantInput
                                                        label="Hardware Component"
                                                        value={item?.name}
                                                        disabled={true}
                                                      />
                                                    </div>
                                                    <div className="col-md-4">
                                                      <DropDownInput
                                                        label="Status"
                                                        data={[
                                                          {
                                                            id: "Tested",
                                                            name: "Tested",
                                                          },
                                                          {
                                                            id: "Not Tested",
                                                            name: "Not Tested",
                                                          },
                                                          {
                                                            id: "Issue Observed",
                                                            name: "Issue Observed",
                                                          },
                                                        ]}
                                                        getIdValue={(val) =>
                                                          handleStatusDropdownList(
                                                            val.id,
                                                            i,
                                                            item.id,
                                                            item.name
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                    <div className="col-md-4">
                                                      <ConstantInput
                                                        label="Remark"
                                                        handleChange={(val) => {
                                                          handleRemarkDropdownList(
                                                            val,
                                                            i
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </FormSection>
                                    </div>
                                  )}
                              </React.Fragment>
                            ))}

                            <div className="col-md-12 col-sm-2 mt-4">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddSection}
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </FormSection>
                      </div>
                    )}
                  </>
                )}
              {showInput ? (
                <div className="col-sm-4">
                  <ConstantInput
                    label={`Requested By`}
                    value={``}
                    required={true}
                    //isStarRequired={true}
                    handleChange={(val) => {
                      handleInputList(val, "requested_by");
                    }}
                  />
                </div>
              ) : null}

              {siteDetailsList &&
                siteDetailsList !== undefined &&
                siteDetailsList !== null &&
                Object.keys(siteDetailsList).length > 0 && (
                  <div className="col-md-12 ml-1">
                    {totalDistance !== "NaN" && (
                      <h5 style={{ color: "#6c7ae0" }}>
                        you are {Number(totalDistance).toFixed(2)} KM away from
                        site
                      </h5>
                    )}
                    <div className="row pointer-where-are-you">
                      <div className="col-m-6">
                        <img src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png" />{" "}
                        : <strong>You{"\u00a0\u00a0"} </strong>
                        (Lat: {islatlng?.lat} {"\u00a0\u00a0"} Long:{" "}
                        {islatlng?.lng})
                      </div>
                      <div className="col-m-6">
                        <img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png" />{" "}
                        : <strong>Site {"\u00a0\u00a0"}</strong>
                        {siteDetailsList !== undefined &&
                          siteDetailsList !== null &&
                          Object.keys(siteDetailsList).length > 0 && (
                            <>
                              (Lat: {siteDetailsList["lead"]["latitude"]}{" "}
                              {"\u00a0\u00a0"} Long:{" "}
                              {siteDetailsList["lead"]["longitude"]})
                            </>
                          )}
                      </div>
                    </div>
                    <div className="map">
                      <div className="google-map">
                        {/* {(mapLocation && mapLocation.lat && siteDetailsList?.lead?.latitude &&
                                                <GoogleMapReact
                                                    bootstrapURLKeys={{key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ'}}
                                                    defaultCenter={mapLocation}
                                                    defaultZoom={15}
                                                    yesIWantToUseGoogleMapApiInternals
                                                    onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
                                                >
                                                </GoogleMapReact>
                                            )} */}
                      </div>
                    </div>
                  </div>
                )}
              <div className="col-md-12 col-sm-4 mt-3">
                <TextAreaInput
                  type="text"
                  rows={6}
                  className={`inline-css scrollbar-styling`}
                  label={localization.description}
                  value={desc}
                  inputValue={desc}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => {
                    setDesc(e.target.value);
                  }}
                />
              </div>

              <div className="col-sm-6 mb-4" style={{ marginLeft: "-41px" }}>
                <div className="col-sm-2 ml-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={inputList.l2_ticket}
                    onChange={(e) => handleL2Ticket(e)}
                    style={{ marginLeft: "3%" }}
                    required
                  />
                </div>
                <div className="col-sm-10">
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckChecked"
                  >
                    {localization.sendL2Ticket}
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-sm-5">
              <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default EngineerTasksForm;
